import constants from '@/constants/constants'

export default {
    name: "InteractiveHomePageDesktopView",
    functional: true,
    render(h, ctx) {
        return h(constants.FORM_TYPES.INTERACTIVE_FORM.INTERACTIVE_HOME_PAGE_LAYOUTS_BY_KEY[ctx.props.pageObj.layout].component, ctx.data)
    }
}